import { createContext, useEffect } from 'react'
import type { ReactNode } from 'react'
import { useAuthProvider } from '../graphql/hooks/useAuthProvider'
import type { User } from '../graphql/types/user'


// Heavily inspired by https://usehooks.com/useAuth/

/**
 * Definition for AuthContext
 */
export interface IAuthContext {
  /**
   * The users abilities
   */
  /**
   * The user itself. If the person is not authenticated the object is null
   */
  user?: User
  /**
   * The JWT token which is used for authentication
   */
  token: string

  /**
   * Admin or user
   */
  userType: 'admin' | 'user' | string


  userName: string

  userId: string
  /**
   * Signs in a User with the given credentials
   */
  signIn: (username: string, password: string) => Promise<boolean>

  /**
   * Checks if token is still alive
   */
  getUserData: () => Promise<void>

  /**
   * Signs out a user
   */
  signOut: () => Promise<void>
}

export const AuthContext = createContext<IAuthContext | null>(null)

/**
 * Populates an implementation of AuthContext to its children.
 *
 */

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const auth = useAuthProvider()
  const { getUserData } = auth
  useEffect(() => {
    void getUserData()
  }, [getUserData])
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>
}